import { memo } from 'react';
import { useAsync } from 'react-use';
import { IPlayer } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils, ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { TeamService } from '@zmedia/bm-soccer-ui/service/TeamService';
import {
    Element,
    Image,
    Menu,
    RouterLink,
    Section,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import styles from './style.module.scss';

export function TeamSquad(props: any) {
    const { id, primaryTournament = {} } = props;
    let data = props.data || {};

    if (ObjectUtils.isEmpty(data)) {
        const state = useAsync(
            () =>
                TeamService.getSquad({
                    id: id,
                    seasonId: primaryTournament.currentSeason,
                }),
            [id, primaryTournament.currentSeason]
        );

        data = state.value?.data || {};
    }

    const { players = [], coach = {} } = data;

    players.sort((playerA: IPlayer, playerB: IPlayer) => {
        return playerA.position.id - playerB.position.id;
    });

    const groupPosition = ArrayUtils.groupByPosition(players);

    const renderStatPlayer = (item: IPlayer, index: number) => {
        if (!item.id) {
            return null;
        }
        return (
            <Menu.List.Item className={styles['team-player-item']} key={index}>
                {item.position ? (
                    <RouterLink
                        to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
                        title={item.name}
                    >
                        <Avatar avatar={item.avatar} name={item.name} />
                        <Element className={styles['player-info']}>
                            <Element className={styles['text']}>
                                {item.name}
                            </Element>
                            {item.country?.name && (
                                <Element className={styles['sub-text']}>
                                    <Image
                                        src={item.country?.logo || ''}
                                        alt={item.country?.name}
                                    />
                                    {item.country?.name}
                                </Element>
                            )}
                        </Element>
                    </RouterLink>
                ) : (
                    <>
                        <Avatar avatar={item.avatar} name={item.name} />
                        <Element className={styles['player-info']}>
                            <Element className={styles['text']}>
                                {item.name}
                            </Element>
                            {item.country?.name && (
                                <Element className={styles['sub-text']}>
                                    <Image
                                        src={item.country?.logo || ''}
                                        alt={item.country?.name}
                                    />
                                    {item.country?.name}
                                </Element>
                            )}
                        </Element>
                    </>
                )}
            </Menu.List.Item>
        );
    };

    const renderStatPlayers = (items: IPlayer[] = []) => {
        return items.map((item: IPlayer, index: number) => {
            return renderStatPlayer(item, index);
        });
    };

    if (ObjectUtils.isEmpty(data)) {
        return (
            <Section>
                <Empty content="Chưa có thông tin đội hình"></Empty>
            </Section>
        );
    }

    return (
        <>
            {coach.id && (
                <Section>
                    <Title>Huấn luyện viên</Title>
                    <Menu.List className={styles['team-player-list']}>
                        {renderStatPlayers([coach])}
                    </Menu.List>
                </Section>
            )}

            {Object.entries(groupPosition)?.map((matches, index) => {
                return (
                    <Section key={index}>
                        <Title>{matches[0]}</Title>
                        <Menu.List
                            className={styles['team-player-list']}
                            key={index}
                        >
                            {renderStatPlayers(matches[1] as IPlayer[])}
                        </Menu.List>
                    </Section>
                );
            })}
        </>
    );
}

export default memo(TeamSquad);
